import { hasOwnProperty } from "@ciaopeople/cp-shatsu/Utils";
import { isArrayOf, isBoolean, isObject, isString } from "@ciaopeople/cp-shatsu/TypeChecking";
import { UserActionExtraInfo } from "./NotificationDataTypes.js";

export interface BookmarkQueryByUrl {
    url: string
}
export function isBookmarkQueryByUrl(obj: any): obj is BookmarkQueryByUrl {
    return isObject(obj) && isString(obj.url);
}

export interface BookmarkQueryById {
    id: string
}

export function isBookmarkQueryById(obj: any): obj is BookmarkQueryById {
    return isObject(obj) && isString(obj.id );
}


export interface BookmarkQueryByExternalId {
    ext_id: string
}


export function isBookmarkQueryByExternalId(obj: any): obj is BookmarkQueryByExternalId {
    return isObject(obj) && isString(obj.ext_id);
}


export type BookmarkQueryObj = BookmarkQueryByUrl | BookmarkQueryById | BookmarkQueryByExternalId;

export function isBookmarkQueryObj(obj: any): obj is BookmarkQueryObj {
    return isBookmarkQueryByExternalId(obj) ||
            isBookmarkQueryByUrl(obj) ||
             isBookmarkQueryById(obj);
}



export interface BookmarkCheckRequest {
    queries: BookmarkQueryObj[]
}


export function isBookmarkCheckRequest(obj: any): obj is BookmarkCheckRequest {
    return isObject(obj) && isArrayOf(obj.queries, isBookmarkQueryObj);
}

export interface BookmarkQueryWithSaved {
    query: BookmarkQueryObj,
    saved: boolean,
    extra_info?: UserActionExtraInfo
}

export function isBookmarkQueryWithSaved(obj: any): obj is BookmarkQueryWithSaved {
    return isObject(obj) && hasOwnProperty(obj, "query") && isBookmarkQueryObj(obj.query) && isBoolean(obj.saved);
}

export interface BookmarkCheckResponse {
    contents: BookmarkQueryWithSaved[]
}

export function isBookmarkCheckResponse(obj: any): obj is BookmarkCheckResponse {
    return isObject(obj) && isArrayOf(obj.contents, isBookmarkQueryWithSaved);
}


export interface BookmarkedContentsResponse {
    contents: { [k: string]: any }[]
}

export function isBookmarkedContentsResponse(obj: any): obj is BookmarkedContentsResponse {
    return isObject(obj) && isArrayOf(obj.contents, isObject);
}
